import { useState } from 'react';
import CustomSelect from './CustomSelect';
import './AdventureSetup.css';

const DIFFICULTY_OPTIONS = [
  { id: 'easy', name: 'Easy', description: 'Relaxed survival mechanics, more resources' },
  { id: 'normal', name: 'Normal', description: 'Balanced challenge, standard RPG experience' },
  { id: 'hard', name: 'Hard', description: 'Scarce resources, tougher enemies' },
  { id: 'brutal', name: 'Brutal', description: 'Survival is a constant struggle' }
];

const SETTING_OPTIONS = [
  { id: 'classic', name: 'Classic Fantasy', description: 'Traditional taverns, forests, and dungeons', icon: '🏰' },
  { id: 'horror', name: 'Dark Horror', description: 'Haunted manors, cursed villages, and eldritch terrors', icon: '💀' },
  { id: 'winter', name: 'Frozen North', description: 'Blizzards, ice caves, and frozen wilderness', icon: '❄️' },
  { id: 'seafaring', name: 'High Seas', description: 'Ships, pirates, islands, and ocean adventures', icon: '⚓' },
  { id: 'fjords', name: 'Viking Fjords', description: 'Norse-inspired longhouses, cliffs, and raiders', icon: '⛰️' },
  { id: 'desert', name: 'Scorching Sands', description: 'Oases, ancient tombs, and endless dunes', icon: '🏜️' },
  { id: 'underground', name: 'Underdark', description: 'Deep caverns, dwarven halls, and darkness', icon: '🕳️' }
];

export default function AdventureSetup({ character, onStart, onCancel }) {
  const [difficulty, setDifficulty] = useState('normal');
  const [setting, setSetting] = useState('classic');
  const [starting, setStarting] = useState(false);

  const selectedDifficulty = DIFFICULTY_OPTIONS.find(d => d.id === difficulty);
  const selectedSetting = SETTING_OPTIONS.find(s => s.id === setting);

  const handleStart = () => {
    setStarting(true);
    onStart({ difficulty, setting });
  };

  return (
    <div className="adventure-setup-overlay">
      <div className="adventure-setup-panel">
        <div className="setup-header">
          <h2>New Adventure</h2>
          <p className="character-name">with {character.name}</p>
        </div>

        <div className="setup-content">
          {/* Difficulty Selection */}
          <div className="setup-section">
            <label className="section-label">Difficulty</label>
            <CustomSelect
              options={DIFFICULTY_OPTIONS}
              value={difficulty}
              onChange={setDifficulty}
              placeholder="Select difficulty..."
              renderOption={(opt) => (
                <div className="difficulty-option">
                  <span className="option-name">{opt.name}</span>
                  <span className="option-desc">{opt.description}</span>
                </div>
              )}
              renderSelected={(opt) => opt.name}
            />
            {selectedDifficulty && (
              <p className="selection-hint">{selectedDifficulty.description}</p>
            )}
          </div>

          {/* Setting Selection */}
          <div className="setup-section">
            <label className="section-label">Adventure Setting</label>
            <CustomSelect
              options={SETTING_OPTIONS}
              value={setting}
              onChange={setSetting}
              placeholder="Select setting..."
              renderOption={(opt) => (
                <div className="setting-option">
                  <span className="option-icon">{opt.icon}</span>
                  <div className="option-text">
                    <span className="option-name">{opt.name}</span>
                    <span className="option-desc">{opt.description}</span>
                  </div>
                </div>
              )}
              renderSelected={(opt) => (
                <span className="selected-setting">
                  <span className="option-icon">{opt.icon}</span>
                  {opt.name}
                </span>
              )}
            />
          </div>

        </div>

        <div className="setup-footer">
          <button
            className="btn btn-secondary"
            onClick={onCancel}
            disabled={starting}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleStart}
            disabled={starting}
          >
            {starting ? 'Starting Adventure...' : 'Begin Adventure'}
          </button>
        </div>
      </div>
    </div>
  );
}
